var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"statusCheck"},[_c('div',{staticClass:"title"},[_vm._v("物联电梯状态")]),_c('div',{staticClass:"pie"},[_c('div',{attrs:{"id":"statusChart"}})])])
}]

export { render, staticRenderFns }